import { ServerFetch } from '../main-model'

export default class StockChangeInListModel extends ServerFetch {
    getStockChangeInListBy = (data) => this.authFetch({
        url: 'stock-change-in-list/getStockChangeInListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}